import SabalPriceSheetActivity from './PriceSheetActivity';

const SabalPriceSheetCreated = ({ event }: { event: any }) => {
  const priceSheetName = event?.data?.diff?.name?.to || event?.data?.diff?.name;
  return <SabalPriceSheetActivity event={event} actionLabel={`Created a Price Sheet (${priceSheetName})`} />;
};

export default SabalPriceSheetCreated;
